import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "teams", "value", "aria-labelledby", "multi"];
import { fromJS, List } from 'immutable';
// @ts-expect-error Untyped dependency
import { TEAM } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error Untyped dependency
import { isResolved } from 'reference-resolvers/utils';
// @ts-expect-error Untyped dependency
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error Untyped dependency
import AddonTeamSelect from 'ui-addon-teams/components/TeamSelect';
import { getSpecialOptionsForReferenceType } from './quickFilterEditorUtils';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamSelect = _ref => {
  let {
      onChange,
      teams,
      value,
      'aria-labelledby': labelledBy,
      multi
    } = _ref,
    selectProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isLoading = !teams || !isResolved(teams);
  const handleChange = useCallback(({
    target: {
      value: selectedValueOrValues
    }
  }) => {
    onChange(multi ? selectedValueOrValues.toJS() : selectedValueOrValues);
  }, [onChange, multi]);
  return /*#__PURE__*/_jsx(AddonTeamSelect, Object.assign({}, selectProps, {
    anchorType: "button",
    buttonUse: "form",
    isLoading: isLoading,
    multi: multi,
    onChange: handleChange,
    teams: isLoading ? List() : List(teams),
    value: fromJS(value),
    customOptions: List(getSpecialOptionsForReferenceType(TEAM)),
    showTags: true,
    uiFormControlProps: {
      'aria-labelledby': labelledBy
    }
  }));
};
const provideTeams = ResolveReferences(resolvers => {
  const resolver = resolvers[TEAM];
  return resolver ? {
    teams: resolver.all()
  } : {};
});
export default provideTeams(TeamSelect);